<div class="app-bookmarks-dialog">
  <div class="header">
    <h3>Rate your experience</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <form class="charger-form" (ngSubmit)="submitForm()" [formGroup]="formGroup" style="padding-top: 0">
      <div class="error-message" *ngIf="state() === 'error'">
        <mat-icon>error</mat-icon>
        Something went wrong. Please try again later.
      </div>

      <div class="success-message" *ngIf="state() === 'success'">
        <mat-icon>check_circle</mat-icon>
        Successfully added a review.
      </div>

      <div class="rating-stars">
        @for (rating of ratings; track rating) {
          <button class="star-button" type="button" [class.active]="ratingScore >= rating" (click)="ratingScore = rating">
            <mat-icon>star</mat-icon>
          </button>
        }
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Experience</mat-label>
        <mat-select required formControlName="title">
          <mat-option value="Successfully charged">
            Successfully charged
          </mat-option>
          <mat-option value="Couldn’t charge">
            Couldn’t charge
          </mat-option>
          <mat-option value="General comment">
            General comment
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput required formControlName="description"></textarea>
      </mat-form-field>

      <div class="actions" style="margin-left: auto">
        <button mat-button type="button" (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="state() === 'loading' || formGroup.invalid">
          <mat-spinner *ngIf="state() === 'loading'" diameter="20"></mat-spinner>
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
